/** Dwight's PO boxes at the bank: a client's lockbox is one of these. */
export const LOCKBOXES = [75405, 75416, 75470] as const

export const LOCKBOX_OPTIONS = LOCKBOXES.map((lockbox) => ({
  value: String(lockbox),
  label: String(lockbox),
}))
